import React, { useState } from 'react';
import { tokens } from '../../design-system';
import AssumptionsContent from './AssumptionsContent';
import RisksContent from './RisksContent';

const T = {
  paper:     '#F7EFD8',
  paperDeep: '#EEE2BF',
  paperSoft: '#FDF7E5',
  card:      '#FFFBEC',
  ink:       '#2E2109',
  ink2:      '#4A3510',
  inkMuted:  '#6E5A38',
  inkFaint:  '#A39068',
  rule:      '#D7C9A1',
  ruleStrong:'#BFAB79',
  orange:    '#EA7C1F',
  orangeDark:'#C25F0E',
  moss:      '#6B7A3E',
  capRed:    '#C14A33',
  r2: '6px', r3: '10px', r4: '14px', full: '999px',
  sh1: '0 1px 0 rgba(46,33,9,0.06), 0 2px 4px rgba(46,33,9,0.04)',
  sh2: '0 2px 0 rgba(46,33,9,0.04), 0 8px 16px -8px rgba(46,33,9,0.14)',
  sans: '"Nunito", ui-sans-serif, system-ui, -apple-system, sans-serif',
  hand: '"Caveat", "Nunito", cursive',
  mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
};

// Discovery Content — segmented control wrapping Assumptions + Considerations
const DiscoveryContent = ({ idea, onRefetch }) => {
  const [section, setSection] = useState('assumptions');

  const assumptions = idea.assumptions || idea.discovery_questions || [];
  const risks = idea.risks || [];

  return (
    <div>
      {/* Page header */}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 22 }}>
        <div>
          <div style={{ fontFamily: T.hand, fontSize: 22, color: T.orange, lineHeight: 1 }}>what we believe —</div>
          <h1 style={{ fontSize: 30, fontWeight: 800, color: T.ink, margin: '4px 0 6px', letterSpacing: -0.6, fontFamily: T.sans }}>Discovery</h1>
          <p style={{ fontSize: 14, color: T.ink2, margin: 0, fontFamily: T.sans }}>The assumptions baked into your plan, and the things to watch out for.</p>
        </div>
      </div>

      <div style={{
        display: 'flex',
        gap: '2px',
        marginBottom: '24px',
        backgroundColor: T.paperDeep,
        borderRadius: T.r3,
        padding: '3px',
        border: `1px solid ${T.rule}`,
        width: 'fit-content',
      }}>
        {[
          { id: 'assumptions', label: `Assumptions (${assumptions.length})` },
          { id: 'considerations', label: `Considerations (${risks.length})` },
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setSection(tab.id)}
            style={{
              padding: '7px 16px',
              borderRadius: T.r2,
              border: 'none',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: section === tab.id ? 700 : 500,
              backgroundColor: section === tab.id ? T.card : 'transparent',
              color: section === tab.id ? T.ink : T.inkMuted,
              transition: 'all 0.15s ease',
              fontFamily: T.sans,
              boxShadow: section === tab.id ? T.sh1 : 'none',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {section === 'assumptions' && <AssumptionsContent idea={idea} onRefetch={onRefetch} />}
      {section === 'considerations' && <RisksContent idea={idea} onRefetch={onRefetch} />}
    </div>
  );
};

export default DiscoveryContent;
